import { render, staticRenderFns } from "./ownerExpendOrder.vue?vue&type=template&id=1f564652&scoped=true&"
import script from "./ownerExpendOrder.vue?vue&type=script&lang=js&"
export * from "./ownerExpendOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f564652",
  null
  
)

export default component.exports